/**
 * Build endpoint for licenses REST endpoints.
 * The /customer/:customer-id part is already included.
 *
 * @return {String} licenses base URL
 */
export const licensesBaseUrl = "licenses";

export const availableQuantityUrl = `${licensesBaseUrl}/available`;

export const licensePoolsUrl = `${licensesBaseUrl}/licensepools`;

export const licenseAddressEditor = `${licensesBaseUrl}/address-editor`;
